// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cH0fn","container__wrapper":"styles_container__wrapper__ZQw63","skeleton-animation":"styles_skeleton-animation__Lv2A9"};